
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class ProductTagFilterModel extends Model<ProductTagFilterModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'tag', type: 'string' },
		{ name: 'parentTag', type: 'string' },
		{ name: 'inverseParentTagNavigation', type: 'ProductTagFilterModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductTagFilterModel }, properties: () => { return ProductTagFilterModel.classProperties } },
		{ name: 'parentTagNavigation', type: 'ProductTagFilterModel', isHidden: true, isObject: true, new: () => { return new ProductTagFilterModel }, properties: () => { return ProductTagFilterModel.classProperties } },
		{ name: 'parentTagFilter', type: 'ProductTagFilterModel', isHidden: true, isObject: true, new: () => { return new ProductTagFilterModel }, properties: () => { return ProductTagFilterModel.classProperties } },
		{ name: 'parentTagFilters', type: 'ProductTagFilterModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductTagFilterModel }, properties: () => { return ProductTagFilterModel.classProperties } }
	];
	[key: string]: any;
	
	public tag: string;
	public parentTag: string;
	public inverseParentTagNavigation: ProductTagFilterModel[];
	public parentTagNavigation?: ProductTagFilterModel;
	public parentTagFilter?: ProductTagFilterModel;
	public parentTagFilters: ProductTagFilterModel[];
    
	constructor(){
		super();
		this.tag = '';
		this.parentTag = '';
		this.inverseParentTagNavigation = [];
		this.parentTagNavigation = undefined;
		this.parentTagFilter = undefined;
		this.parentTagFilters = [];
		
	}
	getProperties(){
		return ProductTagFilterModel.classProperties;
	}
}

